import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { RegimeApiModel } from '@assetaccountant/core/models/regime-api-model';
import { Register } from '@assetaccountant/core/models/register';
import { AppNavigationService } from '@assetaccountant/core/services/app-navigation.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-regime-selector',
  templateUrl: './regime-selector.component.html',
  styleUrls: ['./regime-selector.component.scss'],
  standalone: false,
})
export class RegimeSelectorComponent implements OnInit, OnChanges, OnDestroy {
  @Input() selectedRegister: Register;

  regimes: RegimeApiModel[] = [];

  selectedRegime: RegimeApiModel | null;

  private subscriptions = [
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.refresh()),
  ];

  constructor(
    private appNavigationService: AppNavigationService,
    private router: Router,
  ) {}

  getIconName(regime: RegimeApiModel | null) {
    if (regime != null && !regime.isAccounts) {
      return 'scale';
    } else {
      return 'book-open';
    }
  }

  ngOnInit() {
    this.regimes = this.appNavigationService.getActiveRegister().regimes;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnChanges() {
    this.refresh();
  }

  refresh() {
    this.selectedRegime = this.appNavigationService.getActiveRegime();
    if (this.selectedRegime && 'regimeName' in this.selectedRegime) {
      throw new Error('Found regimeName in selectedRegime');
    }
  }

  async onUserChangedRegime(regimeId: number) {
    await this.appNavigationService.setRegime(regimeId);
  }
}
